import dayjs from "dayjs";

import { UplotTooltipProps } from "@/utils/uplot-plugins/tooltip-plugin";

export const insiderTooltipContent = ({
  lang,
  tradeUnit,
}: {
  lang: "en" | "zh";
  tradeUnit: string;
}): UplotTooltipProps => ({
  content: (
    <div className="pointer-events-none rounded-lg bg-white p-4 shadow-md">
      <p className="text-xs text-neutral-500" id="date" />
      <p className="pt-1 text-sm font-medium" id="price" />
      <div
        className="hidden min-w-[90px] space-y-2 sm:min-w-[170px]"
        id="insider-info"
      >
        <p className="text-xs text-neutral-500" id="insider-count" />
        <div className="flex flex-wrap items-center justify-between">
          <p className="text-xs font-medium sm:text-sm" id="buy-label" />
          <p className="text-xs font-medium sm:text-sm" id="buy-value" />
        </div>
        <div className="flex flex-wrap items-center justify-between pb-1">
          <p className="text-xs font-medium sm:text-sm" id="sell-label" />
          <p className="text-xs font-medium sm:text-sm" id="sell-value" />
        </div>
        <hr />
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="mt-px h-3 w-3 shrink-0" id="indicator" />
            <p className="text-xs font-medium sm:text-sm" id="total-label" />
          </div>
          <p className="text-xs font-medium sm:text-sm" id="total-value" />
        </div>
      </div>
    </div>
  ),
  renderContent: ({ u, dataIndex, container }) => {
    const [
      dateUnix,
      price,
      total,
      insiderNumber,
      purchaseTradeNumber,
      sellTradeNumber,
      insiderDateUnix,
    ] = u.data.map((row) => row[dataIndex]);

    const date = dayjs
      .unix((total == null ? dateUnix : insiderDateUnix) as number)
      .format(total == null ? "YYYY/MM/DD" : "YYYY/MM");
    const DateEl = container.querySelector("#date") as HTMLParagraphElement;
    DateEl.textContent = date;

    const PriceEl = container.querySelector("#price") as HTMLParagraphElement;
    PriceEl.textContent = price ? `$${+price.toFixed(2)}` : "-";
    PriceEl.classList.toggle("hidden", total != null);

    const InsiderContainer = container.querySelector(
      "#insider-info"
    ) as HTMLDivElement;
    InsiderContainer.classList.toggle("hidden", total == null);

    const InsiderCountEl = container.querySelector(
      "#insider-count"
    ) as HTMLParagraphElement;
    InsiderCountEl.textContent =
      lang === "zh"
        ? `共 ${insiderNumber ?? "-"} 位內部人員交易`
        : `${insiderNumber} Insider Buyers`;
    const BuyLabelEl = container.querySelector(
      "#buy-label"
    ) as HTMLParagraphElement;
    BuyLabelEl.textContent = lang === "zh" ? "買進股數" : "Shares of Buy In";

    const BuyValueEl = container.querySelector(
      "#buy-value"
    ) as HTMLParagraphElement;
    BuyValueEl.textContent = `${purchaseTradeNumber ?? "-"}${tradeUnit}`;

    const SellLabelEl = container.querySelector(
      "#sell-label"
    ) as HTMLParagraphElement;
    SellLabelEl.textContent = lang === "zh" ? "賣出股數" : "Shares of Sell Out";

    const SellValueEl = container.querySelector(
      "#sell-value"
    ) as HTMLParagraphElement;
    SellValueEl.textContent = `${sellTradeNumber ?? "-"}${tradeUnit}`;

    const IndicatorEl = container.querySelector(
      "#indicator"
    ) as HTMLSpanElement;
    IndicatorEl.style.backgroundColor =
      !!total && total > 0 ? "#5A8FD6" : "#F1A958";

    const TotalLabelEl = container.querySelector(
      "#total-label"
    ) as HTMLParagraphElement;
    TotalLabelEl.textContent =
      !!total && total > 0
        ? lang === "zh"
          ? "淨買入股數"
          : "New Buy In"
        : lang === "zh"
        ? "淨賣出股數"
        : "New Sell Out";

    const TotalValueEl = container.querySelector(
      "#total-value"
    ) as HTMLParagraphElement;
    TotalValueEl.textContent = `${total ?? "-"}${tradeUnit}`;
  },
});
